import { useId } from "react"

interface DateRangeFilterProps {
  label: string
  fromValue: string
  toValue: string
  onFromChange: (value: string) => void
  onToChange: (value: string) => void
}

export function DateRangeFilter({
  label,
  fromValue,
  toValue,
  onFromChange,
  onToChange,
}: DateRangeFilterProps) {
  const id = useId()
  return (
    <fieldset className="space-y-1 sm:col-span-2 border-none p-0 m-0">
      <legend className="text-xs font-medium text-muted-foreground">
        {label}
      </legend>
      <div className="flex items-center gap-2">
        <input
          id={`${id}-from`}
          type="date"
          value={fromValue || ""}
          onChange={(e) => onFromChange(e.target.value)}
          aria-label={`${label} od`}
          className="h-8 flex-1 rounded-md border border-input bg-transparent px-2 text-sm text-foreground outline-none"
        />
        <span className="text-xs text-muted-foreground">
          do
        </span>
        <input
          id={`${id}-to`}
          type="date"
          value={toValue || ""}
          onChange={(e) => onToChange(e.target.value)}
          aria-label={`${label} do`}
          className="h-8 flex-1 rounded-md border border-input bg-transparent px-2 text-sm text-foreground outline-none"
        />
      </div>
    </fieldset>
  )
}
